import styled, { css } from 'styled-components';
import { HEADER_Z_INDEX } from '../../styles/zIndexes';
import { floatingComponentStyles } from '../../styles/shareableStyles';
import { theme } from '../../styles/theme';

export const IconContainer = styled.div<{ $isActive?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.8);
  &:hover {
    background-color: rgba(255, 255, 255, 0.25);
    color: ${theme.colors.white};
    cursor: pointer;
  }
  ${({ $isActive }) =>
    $isActive &&
    css`
      background-color: rgba(255, 255, 255, 0.1);
      color: ${theme.colors.white};
      &:hover {
        background-color: rgba(255, 255, 255, 0.1);
      }
    `}
`;

export const Menu = styled.div`
  width: 280px;
  z-index: ${HEADER_Z_INDEX};
  ${floatingComponentStyles};
`;
